var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.checkRoles(_vm.gcRoles.collaborators)),expression:"$auth.checkRoles(gcRoles.collaborators)"}],staticClass:"text-center greet-user",attrs:{"slot":"no-body","title":_vm.$t('GradeControl.Admin.Title')},slot:"no-body"},[_c('menu-control',{attrs:{"items":_vm.linkItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }